import {Card, Select, SelectItem} from '@nextui-org/react'
import RootAdmin from "../../../../components/layouts/RootAdmin";
import { useState, useEffect } from 'react';
import ReactMapGL, { Marker, Popup } from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { getFetcher } from '../../../../services/api';
import useSWR from "swr";

/**
 * Koordinat yang masuk akal untuk dipasang di peta.
 *
 * Sebagian data master menyimpan koordinat tanpa titik desimal (mis. 25217
 * untuk 2,5217). Mapbox melempar "Invalid LngLat latitude value" untuk nilai
 * semacam itu dan SELURUH halaman peta ikut jatuh - satu baris rusak membuat
 * 245 penanda lain tidak tampil. Baris yang menyimpang dilewati saja.
 */
const koordinatSah = (lat, lon) => {
  // Number(null) dan Number('') = 0, jadi nilai kosong harus ditolak lebih dulu
  if (lat == null || lon == null || lat === '' || lon === '') return false;
  const y = Number(lat);
  const x = Number(lon);
  return Number.isFinite(y) && Number.isFinite(x) && Math.abs(y) <= 90 && Math.abs(x) <= 180;
};

const PengangkutanMaps = () => {
    const [tipe, setTipe] = useState('perusahaan')
    const [viewport, setViewport] = useState({
        latitude: -1.3911261987874894,
        longitude: 113.4216565328876,
        zoom: 5,
    });

    const endpoint = `/api/dashboard/pelaporan-pengangkutan/peta/${tipe === 'rute' ? 'tujuan-bongkar' : tipe}`
    const { data: map, mutate: mutateMap } = useSWR(endpoint, getFetcher);
    console.log(map, 'isi map')
  const [selectedPoint, setSelectedPoint] = useState(null);

  const handleViewportChange = (newViewport) => {
    setViewport(newViewport);
  };

  function titlePage(data) {
      switch (data) {
          case 'perusahaan':
              return 'Peta Sebaran Perusahaan Pengangkutan';
          case 'perusahaan-terbanyak':
              return 'Peta Sebaran Perusahaan Terbanyak Melakukan Pengangkutan';
          case 'perusahaan-pelaporan':
              return 'Peta Sebaran Perusahaan Terbanyak Melakukan Pelaporan';
          case 'bahanb3-terbanyak':
              return 'Peta Sebaran B3 Terbanyak Diangkut';
          case 'asal-muat':
              return 'Peta Sebaran Asal Muat';
          case 'tujuan-bongkar':
              return 'Peta Sebaran Tujuan Bongkar';
          case 'rute':
              return 'Peta Rute Pengangkutan';
          case 'sebaran-bahanb3-province':
              return 'Peta Sebaran B3 Terbanyak Berdasarkan Provinsi';
          case 'sebaran-bahanb3-regencies':
              return 'Peta Sebaran B3 Terbanyak Berdasarkan Kota';
          default:
              return ''
      }
  }

  function renderPopup(data) {
      switch (data) {
          case 'bahanb3-terbanyak':
              return (
                  <Popup
                      latitude={selectedPoint.latitude}
                      longitude={selectedPoint.longitude}
                      onClose={() => setSelectedPoint(null)}
                      closeButton={true}
                      closeOnClick={false}
                  >
                      <div>
                          <h3><strong>Nama Bahan Kimia:</strong> {selectedPoint.namaBahanKimia}</h3>
                          <p><strong>Cas Number:</strong> {selectedPoint.casNumber}</p>
                          <p><strong>Total:</strong> {selectedPoint.sum}</p>
                      </div>
                  </Popup>
              )
          case 'asal-muat':
              return (
                  <Popup
                      latitude={selectedPoint.latitude}
                      longitude={selectedPoint.longitude}
                      onClose={() => setSelectedPoint(null)}
                      closeButton={true}
                      closeOnClick={false}
                  >
                      <div>
                          <h3><strong>Nama Perusahaan:</strong> {selectedPoint.namaPerusahaan}</h3>
                          <p><strong>Alamat:</strong> {selectedPoint.alamat}</p>
                      </div>
                  </Popup>
              )
          case 'tujuan-bongkar':
              return (
                  <Popup
                      latitude={selectedPoint.latitude}
                      longitude={selectedPoint.longitude}
                      onClose={() => setSelectedPoint(null)}
                      closeButton={true}
                      closeOnClick={false}
                  >
                      <div>
                          <h3><strong>Nama Perusahaan:</strong> {selectedPoint.namaPerusahaan}</h3>
                          <p><strong>Alamat:</strong> {selectedPoint.alamat}</p>
                          <p><strong>Asal Tujuan:</strong> {selectedPoint.locationTypeAsalMuat}</p>
                      </div>
                  </Popup>
              )
          case 'rute':
              return (
                  <Popup
                      latitude={selectedPoint.latitude}
                      longitude={selectedPoint.longitude}
                      onClose={() => setSelectedPoint(null)}
                      closeButton={true}
                      closeOnClick={false}
                  >
                      <div>
                          <h3><strong>Nama Perusahaan:</strong> {selectedPoint.namaPerusahaan}</h3>
                          <h3><strong>Asal:</strong> {selectedPoint.locationTypeAsalMuat}</h3>
                          <h3><strong>Tujuan:</strong> {selectedPoint.locationTypeTujuan}</h3>
                          <p><strong>Alamat:</strong> {selectedPoint.alamat}</p>
                      </div>
                  </Popup>
              )
          case 'sebaran-bahanb3-regencies':
              return (
                  <Popup
                      latitude={selectedPoint.latitude}
                      longitude={selectedPoint.longitude}
                      onClose={() => setSelectedPoint(null)}
                      closeButton={true}
                      closeOnClick={false}
                  >
                      <div>
                          <h3><strong>Nama Provinsi:</strong> {selectedPoint.provinceName}</h3>
                          {selectedPoint.bahanB3.map(it => (
                              <>
                                  <h3><strong>Nama Bahan Kimia:</strong> {it.namaBahanKimia}</h3>
                                  <h3><strong>Nama Dagang:</strong> {it.namaDagang}</h3>
                                  <p><strong>Total:</strong> {it.jumlahB3}</p>
                              </>
                          ))}
                      </div>
                  </Popup>
              )
          case 'sebaran-bahanb3-province':
              return (
                  <Popup
                      latitude={selectedPoint.latitude}
                      longitude={selectedPoint.longitude}
                      onClose={() => setSelectedPoint(null)}
                      closeButton={true}
                      closeOnClick={false}
                  >
                      <div>
                          <h3><strong>Nama Provinsi:</strong> {selectedPoint.provinceName}</h3>
                          {selectedPoint.bahanB3.map(it => (
                              <>
                                  <h3><strong>Nama Bahan Kimia:</strong> {it.namaBahanKimia}</h3>
                                  <h3><strong>Nama Dagang:</strong> {it.namaDagang}</h3>
                                  <p><strong>Total:</strong> {it.jumlahB3}</p>
                              </>
                          ))}
                      </div>
                  </Popup>
              )
          default:
              return (
                  <Popup
                      latitude={selectedPoint.latitude}
                      longitude={selectedPoint.longitude}
                      onClose={() => setSelectedPoint(null)}
                      closeButton={true}
                      closeOnClick={false}
                  >
                      <div>
                          <h3><strong>Perusahaan:</strong> {selectedPoint.name}</h3>
                          <p><strong>Alamat:</strong> {selectedPoint.alamatKantor}</p>
                          <p><strong>Total:</strong> {selectedPoint.total}</p>
                      </div>
                  </Popup>
              )
      }
  }

  const filtering = [
        {
            name: 'Perusahaan Terbanyak',
            value: 'perusahaan-terbanyak'
        },
        {
            name: 'Perusahaan Pelaporan',
            value: 'perusahaan-pelaporan'
        },
        {
            name: 'Sebaran B3 Terbanyak',
            value: 'bahanb3-terbanyak'
        },
        {
            name: 'Perusahaan',
            value: 'perusahaan'
        },
        {
            name: 'Asal Muat',
            value: 'asal-muat'
        },
        {
            name: 'Tujuan Bongkar',
            value: 'tujuan-bongkar'
        },
        {
            name: 'Rute Pengangkutan',
            value: 'rute'
        },
        {
            name: 'Sebaran B3 Provinsi',
            value: 'sebaran-bahanb3-province'
        },
        {
            name: 'Sebaran B3 Kota',
            value: 'sebaran-bahanb3-regencies'
        },
    ]

    return (
        <RootAdmin>
           <Card radius='sm' className='col-span-4 p-3'>
                <div className="w-full h-[600px] z-10">
                    <div className={'flex flex-row justify-between mb-5 items-center w-full'}>
                        <div className={'w-1/2'}>
                            <span className='text-primary text-xl font-bold'>{titlePage(tipe)}</span>
                        </div>

                        <div className={'w-1/3'}>
                            <Select
                                radius="sm"
                                label="Filter"
                                labelPlacement="outside"
                                size="md"
                                placeholder='Pilih filter'
                                value={tipe}
                                onChange={(e) => {
                                    setSelectedPoint(null)
                                    setTipe(e.target.value)
                                }}
                            >
                                {filtering?.map(item => (
                                    <SelectItem key={item.value} value={item.value}>{item.name}</SelectItem>
                                ))}
                            </Select>
                        </div>
                    </div>
                  <ReactMapGL
                    {...viewport}
                    mapboxAccessToken='pk.eyJ1Ijoic2liMy1rbGhrIiwiYSI6ImNtMms1ZWVrZjAxb3MybHEyajE5cG5zb28ifQ.aCs5cuGJhZqytwo7zlVl5w'
                    mapStyle="mapbox://styles/sib3-klhk/cm3i4eidd00dn01s9809ze69i"
                    onMove={handleViewportChange}
                    dragPan={true}
                    scrollZoom={true}
                    doubleClickZoom={true}
                    touchZoom={true}
                  >
                    {(map?.responseData ? map?.responseData : map)?.map((point,index) => {
                        if (tipe !== 'rute') {
                            if (!koordinatSah(point.latitude, point.longitude)) return null;
                            return (
                                <Marker key={index} latitude={point.latitude} longitude={point.longitude}>
                                    <div
                                        onClick={() => setSelectedPoint(point)}
                                        style={{ cursor: 'pointer', fontSize: '24px' }}
                                    >
                                        📍
                                    </div>
                                </Marker>
                            )
                        } else {
                            if (!koordinatSah(point.latitudeAsalMuat, point.longitudeAsalMuat)
                                || !koordinatSah(point.latitudeTujuan, point.longitudeTujuan)) return null;
                            return (
                                <div>
                                    <Marker key={`asal-${index}`} latitude={point.latitudeAsalMuat} longitude={point.longitudeAsalMuat}>
                                        <div
                                            onClick={() => setSelectedPoint(point)}
                                            style={{ cursor: 'pointer', fontSize: '24px' }}
                                        >
                                            📍
                                        </div>
                                    </Marker>
                                    <Marker key={`tujuan-${index}`} latitude={point.latitudeTujuan} longitude={point.longitudeTujuan}>
                                        <div
                                            onClick={() => setSelectedPoint(point)}
                                            style={{ cursor: 'pointer', fontSize: '24px' }}
                                        >
                                            📍
                                        </div>
                                    </Marker>
                                </div>
                            )
                        }
                    })}

                    {selectedPoint && renderPopup(tipe)}
                  </ReactMapGL>
                </div>
            </Card>
        </RootAdmin>
    );
};
export default PengangkutanMaps;
